import "./AboutUs.scss";

const AboutUs = () => {
  const footerText =
    "// # $ % @ ' = ) ) ) ] [ [ / / ' ' ' = - \" - \" ~ ^ ; . < > { { { }} ";

  return (
    <div className="aboutus-container">
      <div className="aboutus-container__image-section">
        <img
          src={require("../../assets/images/about/banner.png")}
          alt="Equipe SOMAS"
          className="aboutus-container__image-section__main-image"
        />
      </div>
      <div className="aboutus-container__content-section">
        <div className="aboutus-container__content-section__title-block">
          <h1 className="aboutus-container__content-section__title-block__title">Quem somos</h1>
          <p className="aboutus-container__content-section__title-block__subtitle">Inclusão digital<br />a qualquer pessoa.</p>
        </div>
        <div className="aboutus-container__content-section__description">
          <p>
            Fundada em 2019, com sede em São Paulo, a SOMAS tem como público alvo instituições e grupos que atuam com geração de impacto social e que reconheçam a tecnologia como instrumento de educação.
          </p>
        </div>
      </div>
      <div className="aboutus-container__blocks">
        <div className="aboutus-container__blocks__block">
          <h2>Missão</h2>
          <p>Gerar oportunidade de escolha através da autonomia digital.</p>
        </div>
        <div className="aboutus-container__blocks__block">
          <h2>Visão</h2>
          <ul>
            <li>Integração</li>
            <li>Circularidade</li>
            <li>Horizontalidade</li>
            <li>Afeto e acolhimento</li>
            <li>Transparência e idoneidade</li>
            <li>Pensamento crítico e <br /> honestidade intelectual.</li>
          </ul>
        </div>
        <div className="aboutus-container__blocks__block">
          <h2>Valores</h2>
          <p>Ser reconhecida, até 2030, como uma instituição idônea e catalisadora que integra pensamento crítico computacional e promove autonomia digital.</p>
        </div>
      </div>

      <div className="aboutus-container__signals">
        {[...Array(2)].map((_, i) => (
          <span key={i} style={{ display: 'inline', whiteSpace: 'pre' }}>{footerText.repeat(2)}</span>
        ))}
      </div>
      <section className="team-section">
        <h1 className="team-title">Equipe</h1>
        <div className="team-grid">
          <div className="team-member">
            <img src={require('../../assets/images/about/camila.png')} alt="Camila Achutti" className="team-photo" />
            <div className="team-info">
              <div className="team-name">Camila Achutti</div>
              <div className="team-role">Educação</div>
            </div>
          </div>
          <div className="team-member">
            <img src={require('../../assets/images/about/fabio.png')} alt="Fábio Ribeiro" className="team-photo" />
            <div className="team-info">
              <div className="team-name">Fábio Ribeiro</div>
              <div className="team-role">Operações</div>
            </div>
          </div>
          <div className="team-member">
            <img src={require('../../assets/images/about/magela.png')} alt="Camilla Magela" className="team-photo" />
            <div className="team-info">
              <div className="team-name">Camilla Magela</div>
              <div className="team-role">Coordenação de projetos</div>
            </div>
          </div>
          <div className="team-member">
            <img src={require('../../assets/images/about/murilo.png')} alt="Murilo Ciasca" className="team-photo" />
            <div className="team-info">
              <div className="team-name">Murilo Ciasca</div>
              <div className="team-role">Gestão de projetos</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
